import EdLink from './src/index.vue'

/* istanbul ignore next */
EdLink.install = function (Vue) {
  Vue.component(EdLink.name, EdLink)
}

export default EdLink
